import React from 'react'
import TeamLine from "../../components/TeamLine/TeamLine"
// import InfiniteScrollRedirect from "../../components/Infinite-Roll/InfiniteScrol"
const Team: React.FC = () => {
    return (
<React.Fragment>

<div className=" bg-no-repeat bg-center bg-cover h-[29em] w-full bg-[url('https://static.igem.wiki/teams/5058/topoteam.svg')]"/>

<TeamLine/>
{/* <InfiniteScrollRedirect redirectTo="/project/description"/> */}
 </React.Fragment>
)
}

export default Team
